module.exports = "# ロードマップ\n\n追加予定のある機能\n- GUIの変更(実行時間によるfilterの方針変更)\n\n-------------------\n\n"